import React from "react";
import "./mid.css"
import point from "../../assets/mid-banner-points.svg"
import midImage from "../../assets/physical-ai-banner-illustrations.svg"
const MidSection = () => {
  return (
    <section className="mid-section">
      <div className="container">
        <div className="row mid-section-wrapper">
          {/* Left Side Content */}
          <div className="col-12 col-lg-6 col-md-6 col-sm-6">
            <div className="mid-banner-header">
              <h2>
                Not Another Dashboard. A Fleet of AI Agents That Act.
              </h2>
              <p>
                Most observability tools stop at alerts. AgentSRE goes further with a fleet of specialized AI agents that resolve issues before they impact customers — so your engineers focus on building, not firefighting.
              </p>
              <div className="mid-banner-points">
                <div className="point-list">
                  <img src={point} alt="checkmark-icon"/>
                  <p>Translates plain-language questions into governed analysis</p>
                </div>
              <div className="point-list">
                <img src={point} alt="checkmark-icon"/>
                  <p>Explains assumptions and reasoning with citations</p>
                </div>
                <div className="point-list">
                  <img src={point} alt="checkmark-icon"/>
                  <p>Acts autonomously to detect, diagnose, and resolve issues in real time</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side Image */}
          <div className="col-12 col-lg-6 col-md-6 col-sm-6">
            <div className="mid-banner-img">
              <img src={midImage} alt="mid-banner-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidSection;
